import { render, staticRenderFns } from "./BasicYouTubeVideo.vue?vue&type=template&id=6dbaad1f&"
import script from "./BasicYouTubeVideo.vue?vue&type=script&lang=ts&"
export * from "./BasicYouTubeVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports